import React from 'react';
import { showAllMissions } from '../../mission-list/constants';
export const useMissionFilters = () => {
    const [activeFilters, setActiveFilters] = React.useState([]);
    const [sortBy, setSortBy] = React.useState();
    const applyFilter = (column, value) => {
        const filterList = [...activeFilters];
        const newFilterIndex = filterList.findIndex((f) => f.column === column);
        if (newFilterIndex === -1 && value !== showAllMissions && value !== 'active') {
            filterList.push({ column: column, value: [value] });
        }
        else {
            if (value === showAllMissions) {
                filterList.splice(newFilterIndex, 1);
            }
            else if (value === 'active') {
                filterList.splice(newFilterIndex, 1);
                filterList.push({ column: column, value: ['mobilizing', 'inProgress', 'complete'] });
            }
            else {
                filterList[newFilterIndex].value = [value];
            }
        }
        setActiveFilters(filterList);
    };
    const clearFilters = () => {
        setSortBy(undefined);
        setActiveFilters([]);
    };
    const onMissionsSortBy = (column, desc) => {
        setSortBy({ column: column, desc: desc });
    };
    return {
        applyFilter,
        clearFilters,
        onMissionsSortBy,
        sortBy,
        activeFilters,
    };
};
